import styled from '@emotion/styled';

export const SContainer = styled.div``;

export const SHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-right: 16px;
`;
